import Vue from 'vue';
import moment from 'moment';
import vueMoment from 'vue-moment';
import 'moment/locale/ru';
import _ from 'lodash';

Vue.use(vueMoment, {
  moment,
});

declare module 'vue/types/vue' {
  interface VueConstructor {
    moment: any;
  }
}

export function formatDateForServer (date: string | Date, format: string): string {
  return moment(date, format).format('YYYY-DD-MM HH:mm:ss');
}

export function formatDateForServerLastDayInMonth (date: string, format: string): string {
  return moment(date, format).endOf('month').format('YYYY-MM-DD[T00:00:00Z]');
}

export function formatPeriod (dateBegin: string, dateEnd: string, format: string, isAddYearForce: boolean, isUpperCase: boolean): string {
  const begin = moment(dateBegin, format);
  const end = moment(dateEnd, format);
  const isAddYear = moment().year() !== begin.year() || moment().year() !== end.year() || isAddYearForce;

  const compile = (date) => {
    let res = date.format(isAddYear ? 'MMMM YYYY' : 'MMMM');
    return isUpperCase ? _.startCase(res) : res;
  };

  if (begin.year() === end.year() && begin.month() === end.month()) {
    return compile(begin);
  }

  return compile(begin) + '...' + compile(end);
}
